<template>
  <div>
    <el-page-header
      @back="goBack"
      :title="$l('btn_go_back') || '返回'"
      :content="this.$l('label_page_header_view') || '详情'"
    />
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <b-row>
            <b-col md="12" lg="5">
              <b-img
                :src="formData.scmImageUrl?formData.scmImageUrl:'/image/static/img/nopic.jpg'"
                class="max-image"
              ></b-img>
            </b-col>
            <b-col md="12" lg="7">
              <h3>{{formData.scmNo}}</h3>
              <hr />
              <h6 class="m-t-0">{{$l('detail_label_chineseName') || '中文名称'}}：{{formData.scmName?formData.scmName:'--'}}</h6>
              <p class="product-description">{{$l('detail_label_englishName') || '英文名称'}}：{{formData.scmNameEn?formData.scmNameEn:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_supplierCategory') || '供应商类别'}}：--</p>
              <p class="mb-1">{{$l('detail_label_country') || '国家地区名称'}}：{{formData.regionName?formData.regionName:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_province') || '省份名称'}}：{{formData.provinceName?formData.provinceName:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_city') || '城市名称'}}：{{formData.cityName?formData.cityName:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_districtCounty') || '区县名称'}}：{{formData.districtName?formData.districtName:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_detailedAddress') || '详细地址'}}：{{formData.scmAddress?formData.scmAddress:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_remarks') || '备注说明'}}：{{formData.scmMemo?formData.scmMemo:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_modifiedBy') || '修改人'}}：{{formData.modifyByName?formData.modifyByName:'--'}}</p>
              <p class="mb-1">{{$l('detail_label_modificationTime') || '修改时间'}}：{{formData.modifyDate?formData.modifyDate:'--'}}</p>
              <hr />
              <!--              <div class="action">-->
              <!--                <button class="btn btn-outline-success" type="button">Add to Cart</button>-->
              <!--                <button class="btn btn-outline-danger" style="margin-left: 10px;" type="button"><i-->
              <!--                        class="fa fa-heart-o"></i></button>-->
              <!--              </div>-->
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="p-2">
      <b-col md="12" lg="12">
        <b-card>
          <b-row>
            <b-col cols="auto" class="mr-auto p-2">
              <h6 class="card-title mb-0">ATTRIBUTE</h6>
            </b-col>
            <b-col cols="auto" class="p-2 mr-1">
              <a v-b-toggle.collapse-1 role="button">
                <i v-if="isJustShown" class="fa fa-chevron-down" title="收起"></i>
                <i v-else class="fa fa-chevron-up" title="展开"></i>
              </a>
            </b-col>
          </b-row>
          <b-collapse visible id="collapse-1">
            <attribute disabled ref="attribute" :params="attrParams" />
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Attribute from '@/views/digital/components/attribute'
export default {
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.scmCode,
        templateCategoryCode: this.formData.scmCategoryCode,
        masterCategoryCode: this.formData.categoryCode,
        templateType: "S",
      };
    },
  },
  components: {
    Attribute
  },
  // 数据
  data() {
    return {
      isJustShown: false, // 折叠状态
      formData: {
        scmCode: "", // 供应商编码
        scmNo: "", // 供应商编号
        scmName: "", // 供应商名称
        scmNameEn: "", // 供应商英文名称
        scmCategoryCode: "", // 供应商分类编码
        regionCode: "100000", // 国家地区编码
        regionName: "中国", // 国家地区名称
        provinceCode: "", // 省份编码
        provinceName: "",
        cityCode: "", // 城市编码
        cityName: "",
        districtCode: "", // 区县编码
        districtName: "",
        scmAddress: "", // 详细地址
        scmImageCode: "", // 供应商图片
        scmImageUrl: "", // 供应商图片url
        scmMemo: "", // 备注说明
        scmStatus: "", // 有效状态
        createDate: "", // 创建时间
        modifyDate: "", // 修改时间
      },
      provinceOptions: [], //  省份
      cityOptions: [], //  市
      districtOptions: [], //  县
      activeName: "first",
    };
  },
  activated(){
    this.loadData(this.$route.params.scmCode);
  },
  // 生命周期钩子
  mounted() {
    this.loadData(this.$route.params.scmCode);
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      this.isJustShown = isJustShown;
    });
  },
  // 事件处理方法
  methods: {
    loadData(val) {
      let param = { scmCode: val };
      this.$api.scmInfoDetailApi(param).then((res) => {
        this.formData = res.body;
        this.$refs.attribute.load(this.attrParams)
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.el-tag + .el-tag {
  margin-left: 10px;
}
.table-c table {
  height: 30px;
}
.table-c table td {
  border-left: 1px solid #f4f4f4;
  border-bottom: 1px solid #f4f4f4;
  border-right: 1px solid #f4f4f4;
  border-top: 1px solid #f4f4f4;
  padding-left: 5px;
  height: 30px;
}
.table-tr {
  background-color: #fbfcfd;
}
.max-image {
  max-width: 100%;
  max-height: 320px;
  display: block;
}
tr:hover {
  background: #f3f4f6;
}
</style>
